import Thunk from 'src/thunks/index';
import { fetchClassById, fetchUserClasses } from 'src/thunks/classes';
import { Data } from 'src/interfaces/general';
import history from 'src/libs/history';
import { PATH } from 'src/constants/app';
import qs from 'query-string';

const payment = new Thunk();

export type PaymentIntentPayload = {
  class_id?: string;
  user_id?: string;
  class_price_id?: string;
  coupon?: string;
  shouldCheckPrice?: boolean;
  redirect?: string;
  parent_id?: string;
  expired_date?: string;
};

export const createPaymentIntent = payment.create<
  Data<{ client_secret: string; is_paid: boolean }>,
  PaymentIntentPayload
>('stripe/create_payment_intent', {
  onSuccess: ({ dispatch, data, args }) => {
    const { client_secret, is_paid } = data.data;

    if (is_paid) {
      history.push(`/${PATH.CLASS}/${args?.class_id}`);
      return;
    }

    const params = qs.stringify({
      client_secret,
      cp_id: args.coupon,
      pr_id: args.class_price_id,
      expired_date: args.expired_date,
    });

    if (args.redirect) {
      return history.push(`/${args.redirect}/${args?.class_id}?${params}`);
    }

    history.push(`/${PATH.PAYMENT}/${args?.class_id}?${params}`);
  },
});

export type PaymentProcessParams = {
  class_id?: string;
  client_secret?: string;
  cp_id?: string;
  pr_id?: string;
  expired_date?: string;
};

export const fetchResources = payment.fetchResources<
  void,
  PaymentIntentPayload
>('payment', async (arg, { dispatch, getState }) => {
  const res1 = await dispatch(
    fetchClassById({
      id: arg.class_id!,
    }),
  );

  const data = res1.payload as Data<Model.Class>;
  const price = data.data.prices?.find((p) => p.id === arg.class_price_id);

  if (!price && arg.shouldCheckPrice) {
    history.push(PATH.NOT_FOUND);
  }

  await Promise.all([
    dispatch(
      fetchUserClasses({
        class_id: arg.class_id,
        user_id: getState().ui.app.me?.id,
      }),
    ),
  ]);
});
